/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ score: NonNullable<unknown> }} Jobs_Variant_Ats_ScoreInputs */

const en_jobs_variant_ats_score = /** @type {(inputs: Jobs_Variant_Ats_ScoreInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ATS: ${i?.score}%`)
};

const de_jobs_variant_ats_score = /** @type {(inputs: Jobs_Variant_Ats_ScoreInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ATS: ${i?.score}%`)
};

const fr_jobs_variant_ats_score = /** @type {(inputs: Jobs_Variant_Ats_ScoreInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ATS : ${i?.score}%`)
};

const es_jobs_variant_ats_score = /** @type {(inputs: Jobs_Variant_Ats_ScoreInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ATS: ${i?.score}%`)
};

const it_jobs_variant_ats_score = /** @type {(inputs: Jobs_Variant_Ats_ScoreInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ATS: ${i?.score}%`)
};

const nl_jobs_variant_ats_score = /** @type {(inputs: Jobs_Variant_Ats_ScoreInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ATS: ${i?.score}%`)
};

const pl_jobs_variant_ats_score = /** @type {(inputs: Jobs_Variant_Ats_ScoreInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ATS: ${i?.score}%`)
};

const fi_jobs_variant_ats_score = /** @type {(inputs: Jobs_Variant_Ats_ScoreInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ATS: ${i?.score}%`)
};

const da_jobs_variant_ats_score = /** @type {(inputs: Jobs_Variant_Ats_ScoreInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ATS: ${i?.score}%`)
};

const sv_jobs_variant_ats_score = /** @type {(inputs: Jobs_Variant_Ats_ScoreInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ATS: ${i?.score}%`)
};

/**
* | output |
* | --- |
* | "ATS: {score}%" |
*
* @param {Jobs_Variant_Ats_ScoreInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const jobs_variant_ats_score = /** @type {((inputs: Jobs_Variant_Ats_ScoreInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Jobs_Variant_Ats_ScoreInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_jobs_variant_ats_score(inputs)
	if (locale === "fr") return fr_jobs_variant_ats_score(inputs)
	if (locale === "es") return es_jobs_variant_ats_score(inputs)
	if (locale === "it") return it_jobs_variant_ats_score(inputs)
	if (locale === "nl") return nl_jobs_variant_ats_score(inputs)
	if (locale === "pl") return pl_jobs_variant_ats_score(inputs)
	if (locale === "fi") return fi_jobs_variant_ats_score(inputs)
	if (locale === "da") return da_jobs_variant_ats_score(inputs)
	if (locale === "sv") return sv_jobs_variant_ats_score(inputs)
	return en_jobs_variant_ats_score(inputs)
});